import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory, useLocation } from "react-router-dom";

import { authenticateApollo } from 'actions/integrations/apollo';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import _ from 'lodash';
import dateformat from 'dateformat';

import {
  Row,
  Col,
  Button,
  Form,
  Image
} from "react-bootstrap";

import styles from './apollo.module.scss';

import { getBaseUrl } from 'services/util';
import { toast } from 'react-toastify';
import { SuccessToast } from 'components/Toast';

export const ApolloIntegration = () => {
  const dispatch = useDispatch();
  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const location = useLocation()
  const history = useHistory()

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const deactivating = useSelector(state => _.get(state, 'integrations.activated.deactivating', false));
  const saving = useSelector(state => _.get(state, 'integrations.apollo.changes.saving', false));

  let integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'apollo';
  });

  const [state, setState] = useState({
    email: _.get(integration, 'configuration.email', ''),
    apiKey: '',
    error: ''
  });

  useEffect(() => {
    if (integration != null) {
      setState((state) => {
        return {
          ...state,
          email: _.get(integration, 'configuration.email', ''),
        }
      })
    }
  }, [integrations]);

  const handleValueChange = (evt) => {
    setState((state) => {
      return {
        ...state,
        [evt.target.name]: evt.target.value
      }
    })
  }

  const handleSaveClick = () => {
    let request = {
      email: state.email
    }

    if (state.apiKey) {
      request = {
        ...request,
        apiKey: state.apiKey
      }
    }

    dispatch(authenticateApollo(request, (integration) => {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"Apollo Integration Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      dispatch(activatingIntegrationSuccedded(integration));
    }));
  }

  const handleDeleteClick = () => {
    dispatch(deactivateIntegration('apollo', (res) => {
      handleBackClick();
    }))
  }

  const handleRestClick = () => {
    setState((state) => {
      return {
        ...state,
        email: _.get(integration, 'configuration.email', ''),
        apiKey: ''
      }
    })
  }

  const handleBackClick = () => {
    var url = `${baseUrl}/integration-settings/integration`;
    history.push(url);
  }

  const calculatePlaceholder = () => {
    return integration ? `*************** last updated: ${dateformat(integration.createdDate, 'dd mmm yyyy')}` : 'Enter your API Key';
  }

  const integrationData = location.state

  return (
    <div className={styles.apolloContent}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>
      <div className={styles.formContainer}>
        <Row className={styles.cardWrapper}>
          <Col className={styles.integrationDetail} md={5}>
            <div className={styles.logoContainer}>
              <Image src={integrationData.logo} />
            </div>
            <div className={styles.detailContainer}>
              <span className={styles.title}>{integrationData.title}</span>
              <span className={styles.description}>{integrationData.description}</span>
              {integration && <Button variant='secondary' onClick={handleDeleteClick} className={styles.deactivateButton} >{deactivating ? 'Deactivating...' : 'Deactivate'}</Button>}
              {!integration && <span className={styles.inactiveStatus}>INACTIVE</span>}
            </div>
          </Col>
          <Col className={styles.authForm} md={7}>
            <div className={styles.apolloAuthentication}>
              <div className={styles.formWrapper}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label className={styles.inputLabel}>Email</Form.Label>
                  <Form.Control className={styles.inputField} value={state.email} onChange={handleValueChange} name="email" type="email" placeholder="Enter your email" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="apiKey">
                  <Form.Label className={styles.inputLabel}>API Key</Form.Label>
                  <Form.Control className={styles.inputField} value={state.apiKey} placeholder={calculatePlaceholder()} onChange={handleValueChange} name="apiKey" type="text" />
                </Form.Group>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.actionContainer}>
        <Button variant='secondary' onClick={handleRestClick} className={styles.resetButton}>Reset</Button>
        <Button variant='primary' onClick={handleSaveClick} className={styles.saveButton}>{saving ? 'Saving...' : 'Save Changes'}</Button>
      </div>
    </div>
  )
}
